import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import { SITE } from '../siteInfo';
import { LANGUAGES, langFromPath, switchLanguagePath } from '../i18n';

// Defaults come from public/index.html and are restored on pages without their own
const DEFAULT_TITLE = document.title;
const descriptionTag = document.querySelector('meta[name="description"]');
const DEFAULT_DESCRIPTION = descriptionTag ? descriptionTag.content : '';

// <link rel="alternate" hreflang="..."> so search engines pair the TR and EN pages
function setAlternate(hreflang, href) {
    let link = document.head.querySelector(`link[rel="alternate"][hreflang="${hreflang}"]`);
    if (!link) {
        link = document.createElement('link');
        link.rel = 'alternate';
        link.hreflang = hreflang;
        document.head.appendChild(link);
    }
    link.href = href;
}

const Layout = ({ title, description, children }) => {
    const { pathname, hash } = useLocation();
    const lang = langFromPath(pathname);

    useEffect(() => {
        document.title = title ? `${title} | ${SITE.name}` : DEFAULT_TITLE;
        if (descriptionTag) {
            descriptionTag.content = description || DEFAULT_DESCRIPTION;
        }
    }, [title, description]);

    useEffect(() => {
        document.documentElement.lang = lang;
        LANGUAGES.forEach(({ code }) => setAlternate(code, SITE.url + switchLanguagePath(pathname, code)));
        setAlternate('x-default', SITE.url + switchLanguagePath(pathname, 'tr'));
    }, [pathname, lang]);

    // Client-side navigation keeps the old scroll position, so reset it or jump to the #anchor
    useEffect(() => {
        const target = hash && document.getElementById(hash.slice(1));
        if (target) {
            target.scrollIntoView();
        } else {
            window.scrollTo(0, 0);
        }
    }, [pathname, hash]);

    return (
        <div className="flex flex-col min-h-screen bg-gray-50">
            <div className="sticky top-0 z-50">
                <Navbar />
            </div>

            <main className="flex-grow">
                {children}
            </main>

            <Footer />
        </div>
    );
};

export default Layout;
